import { HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { inject } from '@angular/core';
import { HttpErrorHandler } from './error-handler.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {

  const errorHandler = inject(HttpErrorHandler);

  return next(req).pipe(
    catchError((err) => {
      errorHandler.handle(err, req, next);
      return throwError(() => err);
    })
  );
};


